export default "__VITE_ASSET__CXeqiqOd__"